import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ds_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    // Pydantic 422 errors: [{loc:["body","field"], msg:"...", type:"..."}]
    return detail
      .map((e) => {
        if (!e || typeof e !== "object") return String(e);
        const field = Array.isArray(e.loc)
          ? e.loc.filter((x) => x !== "body").join(".")
          : "";
        const msg = typeof e.msg === "string" ? e.msg : "";
        if (field && msg) return `Campo "${field}": ${msg}`;
        return msg || JSON.stringify(e);
      })
      .filter(Boolean)
      .join(" · ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
